import i18n                 from "i18next";
import { initReactI18next } from "react-i18next";
import {isUAHost} from "./helper/host";
import UAConsts from "./ua/consts";

const resources = {
  sk: {
    translation: {
      "fmDateTime": "{{val, datetime}}",
      "fmCurrency": "{{val, currency(EUR)}}",
      "general-and": "a",
      "general-show": "Zobraziť",
      "general-send": "Odoslať",
      "general-save": "Uložiť",
      "general-save-and-insert-next": "Uložiť a pridať ďaľší",
      "general-data-saved": "Dáta uložené",
      "general-email": "Email",
      "general-phone": "Mobilné telefónne číslo",
      "general-required": "povinné",
      "general-form-failed-to-send": "Formulár sa nepodarilo odoslať.",
      "general-not-found": "Požadovaná stránka sa nenašla",
      "general-logout": "Odhlásiť sa",
      "general-search": "Hľadaj",
      "general-no-data": " Nenašli sa žiadne dáta",
      "general-project-ua": "Ukrajinský žiak",
      "general-project-sk": "Digitálny žiak",

      "verification-code": "Verifikačný kód",
      "verification-success": "Overenie prebehlo úspešne",
      "verification-failed-phone": "Nepodarilo sa overiť telefónne číslo",
      "verification-failed-email": "Nepodarilo sa overiť email",
      "verification-email": "Overenie emailu",
      "verification-phone": "Overenie telefónneho čísla",
      "verification-missing-phone-sms": "Neprišla mi overovacia SMS",
      "verification-resend-sms-title": "Odoslanie validačnej SMS",
      "verification-student-idnumber": "Rodné číslo študenta",
      "verification-parent-phone": "Tel. číslo zákonného zástupcu",
      "verification-resend-sms-success": "Overovacia SMS bola odoslaná",
      "verification-resend-sms-failed": "Nepodarilo sa odoslať overovaciu SMS",

      "verify-registration": "Overenie registrácie",
      "verify-registration-success": "Uvedené r.č. žiaka je úspešne registrované v projekte {{project, string}}",
      "verify-registration-failed": "Nepodarilo sa overiť r.č. v projekte {{project, string}}. Skúste prosím neskôr.",
      "verify-registration-parent-idnumber": "Registrované r.č. zákonného zástupcu",
      "verify-registration-parent-idnumber-ua": "r.č. resp. iný zaregistrovaný identifikátor zákonného zástupcu",
      "verify-registration-validated-ok": "Máte potvrdený nárok na poskytnutie príspevku",
      "verify-registration-validated-fail": "Nemáte potvrdený nárok na poskytnutie príspevku",
      "verify-registration-phone-ok": "Máte overené telefónne číslo v registrácii.",
      "verify-registration-phone-fail": "Nemáte overené telefónne číslo v registrácii. Overiť si svoje telefónne číslo môžete tu: <a href=\"/vp/\">link</a>",

      "transfer-title": "Presun poukazu do UA projektu",
      "transfer-consent": "Súhlasím s presunom z projektu Digitálny žiak do projektu Ukrajinský žiak",
      "transfer-confirmed": "Súhlas na presun registrácie bol potvrdený",
      "transfer-failed": "Nepodarilo sa zaznamenať súhlas na presun registrácie",

      "resend-code": "Opätovné zaslanie vouchru",
      "resend-code-desc": "Pre opätovné zaslanie vouchru vyplňte správne údaje, ktorými ste sa registrovali.",
      "resend-code-success": "SMS s kódom bola odoslaná",
      "resend-code-failed": "Nepodarilo sa odoslať SMS s kódom",

      "validation-invalid-value": "Nesprávna hodnota",
      "validation-invalid-name": "Meno je povinné",
      "validation-invalid-surname": "Priezvisko je povinné",
      "validation-invalid-name-ua": "Meno je povinné a musí byť zadané latinkou",
      "validation-invalid-surname-ua": "Priezvisko je povinné a musí byť zadané latinkou",
      "validation-invalid-idnumber": "Rodné číslo je nesprávne",
      "validation-invalid-ico": "IČO je nesprávne",
      "validation-invalid-town": "Mesto je povinné",
      "validation-invalid-address": "Adresa je povinná",
      "validation-invalid-postcode": "PSČ je povinné",
      "validation-invalid-phone": "Tel. číslo je nesprávne",
      "validation-invalid-email": "Email je nesprávny",
      "validation-invalid-school": "Vyberte prosím školu",
      "validation-invalid-code": "Kód je povinný",
      "validation-invalid-voucher-code": "Kód je povinný",
      "validation-invalid-password": "Heslo nie je v správnom formáte",
      "validation-cant-be-empty": "Pole nemôže byť prázdne",
      "validation-must-be-selected": "Musíte vybrať možnosť",
      "validation-invalid-password-dont-match": "Zadané heslá sa nezhodujú",
      "validation-invalid-date": "Dátum je nesprávny",
      "validation-date-preceded": "Dátum od musí byť skôr ako dátum do",
      "validation-references-invalid": "Referencie musia byť čísla na každom riadku jedno",
      "validation-ifonumbers-invalid": "IFO čísla musia byť čísla na každom riadku jedno",
      "validation-invalid-ifo": "Identifikátor odídenca je nesprávny",
      "validation-nationality": "Uveďte štátnu príslušnosť",
      "validation-relationship": "Uveďte právny vzťah",
      "validation-student-adult": "Podľa vášho Rodného čísla už máte 18 rokov, čo znamená, že sa, žiaľ, nemôžete zúčastniť projektu \"Ukrajinský žiak\".",
      "validation-invalid-ua-danove-cislo": "Ukrajinské osobné daňové číslo je nesprávne",
      "validation-invalid-passport": "Číslo cestovného pasu je nesprávne",
      "validation-invalid-driving-license": "Číslo vodičského preukazu je nesprávne",
      "validation-invalid-checkbox": "Vyžaduje sa zakliknúť možnosť",

      "hint-name": "latinkou",
      "hint-select": "výber zo zoznamu",
      "hint-idnumber": "možné zadať s lomítkom aj bez lomítka",
      "hint-ico": "vo formáte 12345678 alebo 123456789012",
      "hint-postcode": "vo formáte 12345",
      "hint-email": "vo formáte xx@xx.xx",
      "hint-phone": "vo formáte 09XX123456 alebo v medzinárodnom formáte",
      "hint-phone-validated": "vo formáte 09XX123456 alebo v medzinárodnom formáte - na toto číslo zašleme overovaciu SMS",
      "hint-phone-ua": "v medzinárodnom formáte +421987654321 alebo +380123456789",
      "hint-phone-validated-ua": "v medzinárodnom formáte +421987654321 alebo +380123456789 - na toto číslo zašleme overovaciu SMS",
      "hint-address": "які вказано на посвідченні особи; якщо у вашому документі не вказана адреса, залиште поле пустим",

      "registration": "Registrácia",
      "registration-title": "Registračný formulár žiaka<br/>k projektu \"Digitálny žiak\"",
      "registration-subtitle": "Pozor: Termín registrácie predĺžený!<br/>Registráciu prvákov resp. kvintánov stredných škôl v školskom roku 2023/2024 je potrebné vykonať do 30.9.2023.<br/>Registráciu žiakov z ostatných cieľových skupín je potrebné vykonať do 30.09.2023.",
      "registration-title-ua": "Registračný formulár študenta<br/>k projektu \"Ukrajinský žiak\"",
      "registration-subtitle-ua": "Registráciu je potrebné vykonať do 10.11.2023.",
      "registration-subtitle-2-ua": "Študent musí byť občanom Ukrajiny vo veku do 18 rokov, musí mať štatút dočasného útočiska alebo prechodný pobyt udelený po 24.02.2022.",
      "registration-student-title": "Údaje o žiakovi / študentovi",
      "registration-university-student": "Študent/ka vysokej školy na Slovensku",
      "registration-school": "Škola",
      "registration-school-ua": "Škola na Slovensku",
      "registration-school-ua-hint": "začnite písať adresu slovenskej školy a vyberte zo zoznamu",
      "registration-school-university-ua-hint": "začnite písať názov slovenskej vysokej školy / univerzity a vyberte zo zoznamu",
      "registration-school-checkbox": "Nie je žiakom slovenskej školy",
      "registration-school-checkbox-hint": "rodičia ma skúšali zapísať na slovenskú školu, ale, žiaľ, neboli voľné miesta",
      "registration-city-ua-hint": "začnite písať názov mesta alebo obce na Slovensku a vyberte zo zoznamu",
      "registration-name": "Meno",
      "registration-surname": "Priezvisko",
      "registration-idnumber-general": "Identifikátor osoby",
      "registration-idnumber-general-hint": "rodné číslo, pas, identifikátor odídenca, číslo vodičského preukazu...",
      "registration-idnumber": "Rodné číslo",
      "registration-idnumber-ua": "Identifikačné číslo podľa dokladu",
      "registration-idnumber-2": "alebo Ukrajinské osobné daňové číslo (ІПН alebo РНОКПП)",
      "registration-idnumber-3": "Aby vás predajca mohol ľahšie identifikovať, uveďte prosím Rodné číslo alebo jeden z nižšie uvedených typov informácií.",
      "registration-id-number-type": "Vyberte typ údajov/dokumentu",
      "registration-address": "Ulica a číslo (ako je uvedené na občianskom preukaze)",
      "registration-address-ua-card": "Ulica a číslo (ako je uvedené na dokladoch)",
      "registration-address-ua": "Ulica a číslo, pobyt",
      "registration-address-hint-ua": "na Slovensku alebo na Ukrajine, latinkou. Ak v potvrdení o dočasnom útočisku nie je uvedená adresa, zadajte adresu vašej registrácie na Ukrajine.",
      "registration-address-student": "Ulica a číslo",
      "registration-address-student-hint": "ako je uvedené v Potvrdení o dočasnom útočisku. Ak adresa nie je v Potvrdení uvedená, nechajte pole prázdne.",
      "registration-town": "Mesto (ako je uvedené na občianskom preukaze)",
      "registration-town-ua-card": "Mesto (ako je uvedené na dokladoch)",
      "registration-town-hint": "začnite písať názov mesta alebo obce na Slovensku a vyberte zo zoznamu",
      "registration-town-student": "Mesto",
      "registration-town-student-hint": "ako je uvedené v Potvrdení o dočasnom útočisku, začnite písať názov mesta alebo obce na Slovensku a vyberte zo zoznamu",
      "registration-town-parent": "Mesto",
      "registration-town-parent-hint": "na Slovensku alebo na Ukrajine, latinkou",
      "registration-postcode": "PSČ",
      "registration-postcode-hint": "Ak si nie ste úplne istý svojím slovenským PSČ, použite <a href='https://psc.posta.sk/' target='_blank'>pomôcku</a>",
      "registration-postcode-parent-hint": "na Slovensku alebo na Ukrajine, ak si nie ste úplne istý svojím slovenským PSČ, použite <a href='https://psc.posta.sk/' target='_blank'>pomôcku</a>",
      "registration-name-institution": "Názov",
      "registration-ico": "IČO",
      "registration-title-parent1": "Údaje o zákonnom zástupcovi",
      "registration-title-parent2": "Údaje o druhom zákonnom zástupcovi",
      "registration-parent-is-institution": "Zákonný zástupca je inštitúcia",
      "registration-only-parent1": "Žiak / študent má iba jedného zákonného zástupcu",
      "registration-show-parent1": "Zobraziť údaje o prvom zákonnom zástupcovi",
      "registration-show-parent2": "Zobraziť údaje o druhom zákonnom zástupcovi",
      "registration-ifo": "Identifikátor odídenca",
      "registration-ifo-2": "alebo Číslo cestovného pasu",
      "registration-nationality": "Štátna príslušnosť",
      "registration-relationship": "Právny vzťah",
      "registration-add-parent2": "Pridať druhého zákonného zástupcu",
      "import-ifo-title": "Import IFO čísel",
      "import-ifo-failed": "Import IFO čísel sa nepodaril",
      "import-ifo-numbers": "IFO čísla",
      "import-ifo-numbers-hint": "1 číslo na každý riadok",

      "reason-title": "Žiak alebo študent je (<a href=\"/cielove-skupiny\" target=\"_blank\">bližšie informácie</a>)",
      "reason-title-ua": "Žiak alebo študent je (<a href=\"https://ukrajinskyziak.sk/cielova-skupina-sk\" target=\"_blank\">bližšie informácie</a>)",
      "reason0": "študentom 1. ročníka stredných škôl na SR alebo študentom 5. ročníka (kvinta) 8 ročných vzdelávacích programov stredných škôl na SR",
      "reason1": "v hmotnej núdzi",
      "reason2": "so špeciálnymi vzdelávacími potrebami podľa § 2 písm. p) zákona č. 245/2008 Z.z., ktoré vyplývajú zo sociálne znevýhodneného prostredia",
      "reason3": "členom domácnosti, ktorej spoločný príjem nedosahuje 60% mediánu príjmu",

      "consents": "Súhlasy",
      "consent-title0": "SÚHLAS SO ZMLUVNÝMI PODMIENKAMI",
      "consent-title1": "PODMIENKY OCHRANY OSOBNÝCH ÚDAJOV",
      "consent-title2": "SÚHLAS NA ÚČELY OVERENIA SPLNENIA PODMIENOK CIEĽOVEJ SKUPINY VO VEREJNÝCH REGISTROCH",
      "consent-title3": "SÚHLAS NA PROPAGAČNÉ ÚČELY",
      "consent0": "Potvrdzujem, že som sa oboznámil <a href=\"/zmluvne-podmienky\" target=\"_blank\">Zmluvnými podmienkami</a> participácie na projekte Digitálny príspevok pre žiakov SR a súhlasím s ich znením. Udelením súhlasu vzniká zmluvný vzťah medzi Vami a Digitálnou koalíciou.",
      "consent1": "Potvrdzujem, že som sa oboznámil s <a href=\"/ochrana-osobnych-udajov\" target=\"_blank\">Podmienkami ochrany osobných údajov</a> a porozumel som im.",
      "consent2": "Súhlasím s (i) poskytnutím údajov v rozsahu, ktoré som poskytol/la v rámci registračného formulára,  zo strany Digitálnej koalície vybraným orgánom verejnej správy za účelom vykonania overenia splnenia podmienok cieľovej skupiny Projektu, (ii) spracúvaním poskytnutých údajov orgánmi verejnej správy vykonávajúcimi overenie splnenia podmienok cieľovej skupiny Projektu a (iii) následným poskytnutím výsledku overenia Digitálnej koalícii zo strany orgánov verejnej správy. Digitálna koalícia poskytuje vybraným orgánom verejnej správy, ktoré v rámci vykonávania zverených úloh a presadzovania verejného záujmu, budú spracúvať údaje Dotknutej osoby za účelom overenia splnenia kritérií niektorej z cieľových skupín Projektu v informačných systémoch verejnej správy a následného poskytnutia tejto informácie o overení splnenia podmienok Digitálnej koalícií, čo bude slúžiť ako predpoklad pre zaradenie žiaka medzi oprávnených príjemcov Digitálneho príspevku a plnenie povinností Digitálnej koalície v zmysle Zmluvy o participácii žiaka na Projekte. Získanie výsledku overenia z informačných systémov verejnej správy je nevyhnutnou podmienkou plnenia Zmluvy o participácii žiaka na Projekte. Súhlas udeľujem na obdobie (i) trvania zmluvného vzťahu s Digitálnou koalíciou a 10 rokov po jeho skončení alebo (ii) do 31.12.2028, podľa toho, čo nastane neskôr. Beriem na vedomie, že svoj súhlas môžem kedykoľvek odvolať. Som si vedomý/á, že v prípade odvolania tohto súhlasu, resp. neudelenia tohto súhlasu sa nebudem môcť zúčastniť Projektu a/alebo zaradiť medzi oprávnených príjemcov Digitálneho príspevku. Viac podrobností o odvolaní <a href=\"/suhlas\" target=\"_blank\">súhlasu</a> a Vašich právach nájdete v <a href=\"/ochrana-osobnych-udajov\" target=\"_blank\">Podmienkach ochrany osobných údajov</a>.",
      "consent3": "Súhlasím so spracúvaním mojich kontaktných údajov Digitálnou koalíciou v rozsahu emailová adresa a telefónne číslo na marketingové a propagačné účely s cieľom zvyšovania digitálnej gramotnosti. Som si vedomý/á, že poskytnutie tohto súhlasu nie je potrebné na splnenie žiadnej zmluvnej ani zákonnej povinnosti a jeho neudelenie nebude mať na vyhodnotenie žiadosti o zaradenie do Projektu žiadny vplyv a ani žiadne iné negatívne dôsledky pre osobu zákonného zástupcu, či žiaka. Beriem na vedomie, že svoj súhlas môžem kedykoľvek odvolať. Tento súhlas poskytujem na dobu 3 rokov od jeho udelenia alebo do jeho odvolania. Viac podrobností o odvolaní súhlasu a Vašich právach nájdete v <a href=\"/ochrana-osobnych-udajov\" target=\"_blank\">Podmienkach ochrany osobných údajov</a>.",
      "consent0-ua": "Potvrdzujem, že som sa oboznámil <a href=\"https://ukrajinskyziak.sk/zmluvne-podmienky-sk\" target=\"_blank\">Zmluvnými podmienkami</a> participácie na projekte Digitálny príspevok pre žiakov z Ukrajiny a súhlasím s ich znením. Udelením súhlasu vzniká zmluvný vzťah medzi Vami a Digitálnou koalíciou.",
      "consent1-ua": "Potvrdzujem, že som sa oboznámil s <a href=\"https://ukrajinskyziak.sk/podmienky-ochrany-osobnych-udajov-sk\" target=\"_blank\">Podmienkami ochrany osobných údajov</a> a porozumel som im.",
      "consent2-ua": "Súhlasím s (i) poskytnutím údajov v rozsahu, ktoré som poskytol/la v rámci registračného formulára,  zo strany Digitálnej koalície vybraným orgánom verejnej správy za účelom vykonania overenia splnenia podmienok cieľovej skupiny Projektu, (ii) spracúvaním poskytnutých údajov orgánmi verejnej správy vykonávajúcimi overenie splnenia podmienok cieľovej skupiny Projektu a (iii) následným poskytnutím výsledku overenia Digitálnej koalícii zo strany orgánov verejnej správy. Digitálna koalícia poskytuje vybraným orgánom verejnej správy, ktoré v rámci vykonávania zverených úloh a presadzovania verejného záujmu, budú spracúvať údaje Dotknutej osoby za účelom overenia splnenia kritérií cieľovej skupiny Projektu v informačných systémoch verejnej správy a následného poskytnutia tejto informácie o overení splnenia podmienok Digitálnej koalícií, čo bude slúžiť ako predpoklad pre zaradenie žiaka medzi oprávnených príjemcov Digitálneho príspevku a plnenie povinností Digitálnej koalície v zmysle Zmluvy o participácii žiaka na Projekte. Získanie výsledku overenia z informačných systémov verejnej správy je nevyhnutnou podmienkou plnenia Zmluvy o participácii žiaka na Projekte. Súhlas udeľujem na obdobie (i) trvania zmluvného vzťahu s Digitálnou koalíciou a 10 rokov po jeho skončení alebo (ii) do 31.12.2028, podľa toho, čo nastane neskôr. Beriem na vedomie, že svoj súhlas môžem kedykoľvek odvolať. Som si vedomý/á, že v prípade odvolania tohto súhlasu, resp. neudelenia tohto súhlasu sa nebudem môcť zúčastniť Projektu a/alebo zaradiť medzi oprávnených príjemcov Digitálneho príspevku. Viac podrobností o odvolaní <a href=\"https://ukrajinskyziak.sk/suhlas-sk\" target=\"_blank\">súhlasu</a> a Vašich právach nájdete v <a href=\"https://ukrajinskyziak.sk/podmienky-ochrany-osobnych-udajov-sk\" target=\"_blank\">Podmienkach ochrany osobných údajov</a>.",
      "consent3-ua": "Súhlasím so spracúvaním mojich kontaktných údajov Digitálnou koalíciou v rozsahu emailová adresa a telefónne číslo na marketingové a propagačné účely s cieľom zvyšovania digitálnej gramotnosti. Som si vedomý/á, že poskytnutie tohto súhlasu nie je potrebné na splnenie žiadnej zmluvnej ani zákonnej povinnosti a jeho neudelenie nebude mať na vyhodnotenie žiadosti o zaradenie do Projektu žiadny vplyv a ani žiadne iné negatívne dôsledky pre osobu zákonného zástupcu, či žiaka. Beriem na vedomie, že svoj súhlas môžem kedykoľvek odvolať. Tento súhlas poskytujem na dobu 3 rokov od jeho udelenia alebo do jeho odvolania. Viac podrobností o odvolaní súhlasu a Vašich právach nájdete v <a href=\"https://ukrajinskyziak.sk/podmienky-ochrany-osobnych-udajov-sk\" target=\"_blank\">Podmienkach ochrany osobných údajov</a>.",

      "school-none-consent-title1": "TEST SLOVENSKÉHO JAZYKA",
      "school-none-consent-title2": "IT FITNESS TEST",
      "school-none-consent-title3": "ČESTNÉ VYHLÁSENIE",
      "school-none-consent-info1": "Zaväzujem sa absolvovať <a href=\"https://ukrajinskyziak.sk/test-a1-sk\" target=\"_blank\">Samohodnotiaci test slovenského jazyka ako cudzieho jazyka</a> do 10.10.2023.",
      "school-none-consent-info2": "Zaväzujem sa absolvovať <a href=\"https://itfitness.eu/uk\" target=\"_blank\">IT FITNESS TEST</a> do 10.10.2023.",
      "school-none-consent-info3": "Čestne vyhlasujem, že mám(-e) záujem, aby registrované dieťa bolo zaradené do štátneho vzdelávacieho programu v SR a vykonal (-a, -i sme)  potrebné aktivity k nájdeniu vhodnej školy. Ku dňu registrácie nebolo možné zapísať dieťa do žiadnej vhodnej školy, ktorá by vyhovovala potrebám dieťaťa vzdialenosťou od miesta bydliska, zameraním a študijnými potrebami dieťaťa.",
      "school-none-value": 'žiadna',

      "header-home": "Domov",
      "header-callcentrum": "Callcentrum",

      "footer-company": "Digitálna koalícia — Národná koalícia pre digitálne zručnosti a povolania Slovenskej republiky",
      "footer-company-address-line-1": "Mlynské nivy 5, 821 09",
      "footer-company-address-line-2": "Bratislava Slovenská republika",
      "footer-phone-info": "(pracovné dni, 9:00-17:00)",
      "footer-company-realisation-info": "Projekt je spolufinancovaný Európskou úniou.",
      "footer-company-realisation-info-ua": "Projekt je financovaný Európskou úniou.",
      "footer-more-info": "Viac informácií na",

      "logo-digiziak": "Digitalny žiak logo",
      "logo-digi-coalition": "Logo digitálna koalícia",
      "logo-eu": "Logo európsky fond regionálneho rozvoja",
      "logo-opii": "Logo ministerstvo dopravy a výstavby SR",
      "logo-mirri": "Logo ministrstvo investícií, regionálneho rozvoja a informatizácie SR",

      "consent-required": "Vyžaduje sa súhlas",
      "error-consent-gdpr": "Musíte súhlasiť so spracovaním osobných údajov",
      "error-missing-reason": "Vyberte aspoň jeden dôvod",
      "cookies-settings": "Nastavenie cookies",
      "cookies-necessary": "Nevyhnutné cookies",
      "cookies-necessary-text": "Tieto súbory cookies sú nevyhnutné pre správne a bezpečné fungovanie webovej stránky a nie je možné ich deaktivovať.",
      "cookies-analytics": "Analytické cookies",
      "cookies-analytics-text": "Analytické súbory cookies umožňujú webovej stránke počítať návštevy, zdroje návštev a správanie na webovej stránke s cieľom merať a zlepšiť výkonnosť našej stránky. Na tieto merania používame analytiku iných spoločností - Google Analytics.",
      "cookies-allow-necessary": "Povoliť len nevyhnutné",
      "cookies-allow-selected": "Povoliť vybrané",
      "cookies-allow-all": "Povoliť všetky",

      "result-part1": "Ďakujeme za váš záujem a registráciu. Na uvedené telefónne číslo {{phone, string}} sme zaslali SMS s overovacím kódom, ktorý môžete zadať nižšie.",
      "result-part2": "Po overení vášho telefónneho čísla budú vami zadané údaje overené v štátnych registroch voči splneniu kritérií na získanie príspevku. Overovanie bude vykonávané v dvojtýždňových intervaloch a o jeho výsledku vás budeme informovať na zadanom telefónnom čísle. V prípade otázok kontaktujte infolinku projektu <a href='tel:{{contactPhone,string}}'>{{contactPhone, string}}</a> v pracovných dňoch v čase 9:00 - 17:00 alebo nám pošlite e-mail na <a href='mailto:{{contactEmail,string}}'>{{contactEmail, string}}</a>.",

      "login-title": "Prihlásenie",
      "login-login": "Prihlásiť",
      "login-codeOrPassword": "Heslo alebo kód tutoriálu",
      "login-newPassword": "Nové heslo",
      "login-newPasswordAgain": "Nové heslo ešte raz",
      "login-password": "Heslo",
      "login-failed": "Nepodarilo sa prihlásiť",
      "salesman-validation": "Vyhľadanie poukazu",
      "supervisor-vouchers": "Zoznam poukazov",

      "lookup-title": "Vyhľadanie poukazu",
      "lookup-desc": "Zadajte kód poukazu",
      "lookup-code": "Kód poukazu",
      "lookup-student-idnumber": "Rodné číslo žiaka",
      "lookup-student-idnumber-ua": "Rodné číslo žiaka",
      "lookup-parent-idnumber": "Rodné číslo zákonného zástupcu",
      "lookup-parent-idnumber-ua": "Identifikačný údaj zákonného zástupcu Ukrajinský žiak",
      "lookup-parent-idnumber-hint-ua": "číslo zákonného zástupcu zadané v registrácii: r.č., IFO, PAS, VP, OP UA",

      "voucher-code": "Kód poukazu",
      "voucher-code-hint": "XXX-YYY-ZZZ",
      "voucher-search": "Kód poukazu, meno, rodné číslo ...",
      "voucher-search-hint": "",
      "voucher-detail-title": "Poukaz",
      "voucher-detail-desc": "Detail poukazu",
      "voucher-lock": "Pokračovať v poskytnutí príspevku",
      "voucher-locked-for-other-salesman": "Poukaz je blokovaný pre iného predajcu",
      "voucher-invalid-params": "Zadané hodnoty sú nesprávne",
      "voucher-check-failed": "Nepodarilo sa overiť údaje",
      "voucher-lock-failed": "Nepodarilo sa zamknúť poukaz",
      "voucher-repair-data-and-continue": "Uložiť údaje a pokračovať v poskytnutí príspevku",
      "voucher-process-finish": "Dokončiť poskytnutie príspevku",
      "voucher-process-cancel": "Ukončiť bez poskytnutia príspevku",
      "voucher-cant-load": "Nepodarilo sa načítať poukaz",
      "voucher-process-cancel-confirm": "Naozaj chcete ukončiť poskytovanie príspevku?",
      "voucher-idCard": "Číslo občianskeho preukazu",
      "voucher-idCard-ua": "Číslo dokumentu",
      "voucher-idCard-type": "Typ dokumentu",
      "voucher-sale-without-setup": "Študent 1. ročníka strednej školy - zákazník si neželá inštaláciu a prvé spustenie zariadenia.",
      "voucher-searchByIdOrPhone": "Vyhľadaj podľa rodného / telefónneho čísla",
      "voucher-verified": "overený nárok",
      "voucher-unverified": "neoverený nárok",
      "voucher-refused": "zamietnutý nárok",
      "voucher-refused-detail": "Poukaz má zamietnutý nárok",
      "voucher-unused": "nepoužitý",
      "voucher-appliedAt": "uzamknutý predajcom",
      "voucher-confirmedAt": "použitý",
      "voucher-phoneVerified": "overené tel. číslo",
      "voucher-phoneNotVerified": "čaká na overenie tel. čísla",
      "voucher-salesInfo": "Informácie o predaji",
      "voucher-details": "Informácie o poukaze",
      "voucher-delete": "Odstrániť poukaz (GDPR)",
      "voucher-delete-success": "Poukaz odstránený",
      "voucher-delete-confirm": "Naozaj chcete odstrániť poukaz?",
      "voucher-release-sale-voucher": "Zrušiť predaj",
      "voucher-reject": "Vrátiť na opravu",
      "voucher-return-rejected": "Vrátiť opravavený poukaz na kontrolu",
      "voucher-released-sale-success": "Predaj poukazu bol zrušený",
      "voucher-released-sale-confirm": "Naozaj chcete zrušiť predaj poukazu?",
      "voucher-approve": "Schváliť predaj",
      "voucher-approve-success": "Predaj bol schválený",
      "voucher-approve-confirm": "Naozaj chcete schváliť predaj poukazu? Po schválení už nie je možné editovať poukaz, ani údaje o predaji.",
      "voucher-reject-success": "Poukaz bol vrátený na opravu",
      "voucher-reject-confirm": "Naozaj chcete vrátiť predaj poukazu na opravu? Napíšte dôvod vrátenia.",
      "voucher-rejected": "Poukaz bol vrátený na opravu",
      "voucher-repair-confirm": "Naozaj chcete vrátiť predaj na kontrolu? Predaj následne už nebudete môcť upravovať.",
      "voucher-status-forReview": "Na kontrolu",
      "voucher-status-approved": "Schválený",
      "voucher-status-returned": "Vrátený na opravu",
      "voucher-status-paid": "Uhradený",

      "voucher-paid-title": "Zaplatené poukazy",
      "voucher-paid-date": "Dátum zaplatenia",
      "voucher-paid-references": "Zoznam referencií",
      "voucher-paid-references-hint": "1 referencia na každý riadok",
      "voucher-paid-failed": "Nepodarilo sa označiť poukazy za zaplatené",

      "voucher-check-data-title": "Kontrola údajov poukazu {{voucher, string}}",
      "voucher-check-data-subtitle": "Ak nesedí <strong>adresa</strong> s údajmi v občianskom preukaze, môžete ju opraviť a následne uložiť",
      "voucher-check-data-appendix": "Potvrdzujem, že zadané údaje súhlasia s údajmi v občianskom preukaze",
      "voucher-model-fields-title": "Poukaz {{voucher, string}}",
      "voucher-model-fields": "Informácie o zariadení",
      "voucher-model-field-model": "Model",
      "voucher-model-field-description": "Typ zariadenia",
      "voucher-model-field-serialNumber": "Sériové číslo",
      "voucher-model-field-descriptionAccessories": "Popis oprávneného príslušenstva",
      "voucher-model-field-priceDevice": "Cena zariadenia s DPH",
      "voucher-model-field-priceAccessories": "Cena príslušenstva s DPH",
      "voucher-model-field-totalPrice": "Cena nákupu spolu",
      "voucher-model-field-reference": "Variabilný symbol",
      "voucher-model-updated": "Detaily poukazu aktualizované",
      "voucher-model-desc-select": "Vyberte zo zoznamu",
      "voucher-model-desc-optionNotebook": "Notebook",
      "voucher-model-desc-optionTablet": "Tablet",
      "voucher-model-desc-optionAllInOne": "All in one počítač",
      "voucher-model-update-failed": "Nepodarilo sa uložiť údaje",
      "voucher-type-updated": "Cieľová skupina zmenená",
      "voucher-type-update-failed": "Nepodarilo sa cieľovú skupinu",
      "voucher-model-field-warning": "S účinnosťou od 25.7. nie je možné uplatniť príspevok na doplnkové služby pripoistenia a predĺženej záruky.",

      "voucher-created": "Registrácia vytvorená",
      "voucher-result-title": "Poukaz bol úspešne použitý.",
      "voucher-student": "Žiak",
      "voucher-school": "Škola",
      "voucher-salesman": "Predajca",
      "voucher-parent": "Zákonný zástupca",
      "voucher-groups": "Cieľové skupiny",

      "voucher-title": "Poukaz {{voucher, string}}",
      "voucher-deactivated": "Poukaz deaktivovaný",
      "voucher-deactivate-select": "Vybrať poukaz na deaktivovanie",
      "voucher-deactivate-count_one": "Deaktivovať {{count, number}} poukaz",
      "voucher-deactivate-count_few": "Deaktivovať {{count, number}} poukazy",
      "voucher-deactivate-count_other": "Deaktivovať {{count, number}} poukazov",
      "voucher-deactivate-confirm_one": "Naozaj chcete deaktivovat {{count, number}} poukaz? Akcia je nenávratná.",
      "voucher-deactivate-confirm_few": "Naozaj chcete deaktivovat {{count, number}} poukazy? Akcia je nenávratná.",
      "voucher-deactivate-confirm_other": "Naozaj chcete deaktivovat {{count, number}} poukazov? Akcia je nenávratná.",
      "voucher-deactivate-success_one": "{{count, number}} poukaz úspešne deaktivovaný",
      "voucher-deactivate-success_few": "{{count, number}} poukazy úspešne deaktivované",
      "voucher-deactivate-success_other": "{{count, number}} poukazov úspešne deaktivovaných",

      "attachments": "Prílohy",
      "attachments-upload": "Nahrávanie príloh",
      "attachment": "Príloha",
      "attachment-add": "Nahraj ďaľší doklad",
      "attachment-upload": "Nahraj prílohu",
      "attachment-delete-confirm": "Naozaj chcete odstrániť prílohu? Odstránenie prílohy sa nedá vrátiť späť.",
      "attachment-pleaseUpload": "Prosím, nahrajte všetky povinné prílohy",
      "attachment-contract": "Zmluva",
      "attachment-protocol": "Preberací protokol",
      "attachment-invoice": "Účtovný doklad",
      "attachment-sync-warning": "Pre nahratie dokumentu kliknite na \"Uložiť\"",
      "attachment-sync-failed": "Nepodarilo sa nahrať dokument",
      "attachment-affidavit": "vzor nájdete tu",

      "import-title": "Import používateľov",
      "import-rows": "Importované dáta",
      "import-select-file": "Vyber súbor pre import",
      "import-user-type": "Typ používateľa",
      "import-errorRows": "Chybné dáta v riadkoch: {{rows, string}}",
      "import-user-email-success": "Používateľ úspešne naimportovaný: {{email, string}}",
      "import-user-email-error": "Chyba pri importe používateľa: {{email, string}}. {{error, string}}",
      "import-user-result-success": "Import prebehol úspešne",
      "import-user-result-error": "V importe sa nachádzajú chyby",

      "user-typeAdmin" : "Admin",
      "user-typeSchool" : "Manažér školy",
      "user-typeCallcenter" : "Call centrum",
      "user-typeStoreChain" : "Manažér obchodného reťazca",
      "user-typeSalesman" : "Predajca",

      "vouchers-code": "Kód",
      "vouchers-applied": "Aplikovaný",
      "vouchers-confirmed": "Potvrdený",
      "vouchers-student": "Žiak",
      "vouchers-priceDevice": "Cena zariadenia",
      "vouchers-priceAccessories": "Cena príslušenstva",
      "vouchers-priceTotal": "Cena spolu",

      "export-title": "Export dát",
      "export-dateFrom": "Dátum od",
      "export-dateTo": "Dátum do",
      "export-action-xlsx": "Exportuj .xlsx",
      "export-action-xml": "Exportuj .xml",
      "export-action-mirri": "Export pre MIRRI",
      "storeChain-list-title": "Siete predajní",
      "storeChain-title": "Sieť predajní",
      "storeChain-only-rejected": "Zobraziť iba vrátené",
      "store-title": "Prevádzka",
      "store-search-voucher": "Vyhľadaj kód poukazu",

      "store-sales": "Predaje",
      "store-voucher": "Poukaz",
      "store-sale-created": "Predané",
      "store-sale-price": "Cena",
      "store-sale-item": "Položka",
      "store-salesman": "Predajca",

      "user-name": "Meno",
      "user-email": "Email",
      "user-create-title": "Vytvorenie používateľa",
      "user-edit-title": "Editácia používateľa",
      "user-supervisor": "Supervízor",
      "user-saved": "Používateľ uložený",
      "user-clear-password": "Vymazať heslo",
      "user-clear-password-confirm": "Naozaj chcete vymazať heslo?",
      "user-block": "Blokovať používateľa",
      "user-block-confirm": "Naozaj chcete zablokovať používateľa?",
      "user-blocked": "Používateľ zablokovaný",
      "user-password-cleared": "Heslo vymazané.",
      "user-not-found": "Používateľ neexistuje",
      "user-not-salesman": "Upravovať je možné len predajcov",
      "user-create": "Pridaj používateľa",
      "user-disabled-alert": "Používateľ deaktivovaný.",
      "user-not-activated": "Konto ešte nebolo aktivovanô",

      "relationship-parent": "Rodič",
      "relationship-officially-determined-guardian": "Opatrovník",
      "relationship-authorized-guardian": "Splnomocnená osoba",

      "option-slovak-republic": "Slovenská republika",
      "option-other": "iná",

      "registration-page-title": "Registračný formulár | Ukrajinský žiak",

      "registration-radio-sk-rodne-cislo": "Rodné číslo",
      "registration-radio-ua-tax-id": "Ukrajinské osobné daňové číslo (ІПН alebo РНОКПП)",
      "registration-radio-ua-pass-number": "Cestovný pas",
      "registration-radio-sk-ifo": "Identifikátor odídenca",
      "registration-radio-driver-license": "Vodičský preukaz",
      "registration-radio-temporary-residence": "Prechodný pobyt",
      "ua-title": "Ukrajinský žiak",

      "statistics-user-title": "Štatistika schválení poukazov",
      "statistics-user-user": "Používateľ",
      "statistics-user-email": "Email",
      "statistics-user-seens": "Počet zobrazení",

      "ua-registration-end-title": "Projekt Ukrajinský žiak je ukončený",
      "ua-registration-end-text": "<p>Projekt Ukrajinský žiak je ukončený, uplatnenie príspevku bolo možné do 30. 11. 2023.</p><p>V projekte Digitálny príspevok pre žiakov s Ukrajiny (Ukrajinský žiak) sme prijali a spracovali približne 10 500 registrácií – ďakujeme!</p><p>Overovanie nárokov na príspevok, ako aj distribúcia potvrdzujúcich validačných SMS kódov boli ukončené a uplatnenie príspevku na nákup noveho digitálneho zariadenia bolo následne možné v ktorejkoľvek z viac ako 450 predajní zapojených do projektu do 30. novembra 2023.</p>",
    }
  },
  ua: {
    translation: {
      "fmDateTime": "{{val, datetime}}",
      "fmCurrency": "{{val, currency(EUR)}}",
      "general-and": "та",
      "general-show": "Zobraziť",
      "general-send": "Надіслати",
      "general-save": "Зберегти",
      "general-save-and-insert-next": "Зберегти та додати наступні",
      "general-data-saved": "Дані збережено",
      "general-email": "Email",
      "general-phone": "Номер мобільного телефону",
      "general-required": "обов'язково",
      "general-form-failed-to-send": "Форму не вдалося відправити.",
      "general-not-found": "Запитувану сторінку не знайдено",
      "general-logout": "Вийти з системи",
      "general-search": "Знайти",
      "general-no-data": " Дані не знайдено",
      "general-project-ua": "Ukrajinský žiak",
      "general-project-sk": "Digitálny žiak",

      "verification-code": "Код верифікації",
      "verification-success": "Верифікація пройшла успішно",
      "verification-failed-phone": "Не вдалося верифікувати номер телефону",
      "verification-failed-email": "Не вдалося верифікувати електронну пошту",
      "verification-email": "Верифікація електронної пошти",
      "verification-phone": "Верифікація номера телефону",
      "verification-missing-phone-sms": "Neprišla mi overovacia SMS",
      "verification-resend-sms-title": "Odoslanie validačnej SMS",
      "verification-student-idnumber": "Rodné číslo študenta",
      "verification-parent-phone": "Tel. číslo zákonného zástupcu",
      "verification-resend-sms-success": "Overovacia SMS bola odoslaná",
      "verification-resend-sms-failed": "Nepodarilo sa odoslať overovaciu SMS",

      "verify-registration": "Перевірка реєстрації",
      "verify-registration-success": "Вказаний ідентифікаційний номер (Rodné číslo) учня було успішно зареєстровано в проекті {{project, string}}",
      "verify-registration-failed": "Не вдалося верифікувати ідентифікаційний номер (Rodné číslo) в проекті {{project, string}}. Спробуйте будь ласка пізніше.",
      "verify-registration-parent-idnumber": "Реєстрований ідентифікаційний номер (Rodné číslo) законного представника",
      "verify-registration-parent-idnumber-ua": "Ідентифікаційний номер (Rodné číslo) або інший використаний під час реєстрації ідентифікатор законного представника",

      "resend-code": "Повторне надсилання ваучера",
      "resend-code-desc": "Для повторного надсилання ваучера, будь ласка, заповніть коректні дані, з якими ви реєструвалися.",
      "resend-code-success": "SMS з кодом надіслано",
      "resend-code-failed": "Не вдалося відправити SMS з кодом",

      "validation-invalid-value": "Невірне значення",
      "validation-invalid-name": "Ім'я є обов'язковим та має бути вказано латиницею",
      "validation-invalid-name-ua": "Ім'я є обов'язковим та має бути вказано латиницею",
      "validation-invalid-surname": "Прізвище є обов'язковим та має бути вказано латиницею",
      "validation-invalid-surname-ua": "Прізвище є обов'язковим та має бути вказано латиницею",
      "validation-invalid-idnumber": "Ідентифікаційний номер (Rodné číslo) вказано невірно",
      "validation-invalid-ico": "Ідентифікаційний код (IČO) вказано невірно",
      "validation-invalid-town": "Місто є обов'язковим",
      "validation-invalid-address": "Адреса є обов'язковою",
      "validation-invalid-postcode": "Поштовий індекс є обов'язковим",
      "validation-invalid-phone": "Номер телефону вказано невірно",
      "validation-invalid-email": "Електронна адреса вказана невірно",
      "validation-invalid-school": "Будь ласка, вкажіть школу",
      "validation-invalid-code": "Код є обов'язковим",
      "validation-invalid-voucher-code": "Код є обов'язковим",
      "validation-invalid-password": "Пароль введено у невірному форматі",
      "validation-cant-be-empty": "Поле не може бути порожнім",
      "validation-must-be-selected": "Ви повинні вибрати опцію",
      "validation-invalid-password-dont-match": "Введені паролі не збігаються",
      "validation-invalid-date": "Хибна дата",
      "validation-date-preceded": "Дата від повинна бути раніше, ніж дата до",
      "validation-invalid-ifo": "Ідентифікатор біженця (odídenca) вказано невірно",
      "validation-nationality": "Вкажіть громадянство",
      "validation-relationship": "Вкажіть правові відносини",
      "validation-student-adult": "Згідно з вашим Ідентифікаційним номером (Rodné číslo), Вам вже виповнилося 18 років, а це означає, що, на жаль, Ви не можете взяти участь у проекті \"Український учень\".",
      "validation-invalid-ua-danove-cislo": "Український індивідуальний податковий номер (ІПН або РНОКПП) вказано невірно",
      "validation-invalid-passport": "Номер закордонного паспорту вказано невірно",
      "validation-invalid-driving-license": "Номер посвідчення водія вказано невірно",

      "hint-name": "латиницею, як у закордонному паспорті",
      "hint-select": "вибір зі списку",
      "hint-idnumber": "можна вводити з косою рискою або без неї",
      "hint-ico": "у форматі 12345678 або 123456789012",
      "hint-postcode": "у форматі 12345",
      "hint-email": "у форматі xx@xx.xx",
      "hint-phone": "у форматі 09XX123456 або в міжнародному форматі +380123456789",
      "hint-phone-ua": "в міжнародному форматі +421987654321 або +380123456789",
      "hint-phone-validated": "у форматі 09XX123456 або в міжнародному форматі +380123456789 - ми надішлемо на цей номер перевірочне SMS",
      "hint-phone-validated-ua": "в міжнародному форматі +421987654321 або +380123456789 - ми надішлемо на цей номер перевірочне SMS",
      "hint-address": "які вказано на посвідченні особи; якщо у вашому документі не вказана адреса, залиште поле пустим",

      "registration": "Реєстрація",
      "registration-title": "Реєстраційна форма учня<br/>для участі в проекті \"Український учень\"",
      "registration-subtitle": "Реєстрація повинна бути завершена до 30.09.2023",
      "registration-title-ua": "Реєстраційна форма студента<br/>для участі в проекті \"Український учень\"",
      "registration-subtitle-ua": "Реєстрація повинна бути завершена до 10.11.2023",
      "registration-subtitle-2-ua": "Студент має бути громадянином України віком до 18 років та мати статус тимчасового притулку або дозвіл на тимчасове перебування, отриманний після 24.02.2022. <br> Усі поля мають заповнюватись латиницею.",
      "registration-student-title": "Інформація про учня / студента",
      "registration-university-student": "Студент словацького університету",
      "registration-school": "Школа",
      "registration-school-ua": "Школа в Словаччині",
      "registration-school-ua-hint": "почніть вводити адресу словацької школи та виберіть зі списку",
      "registration-school-university-ua-hint": "почніть вводити назву словацького вищого навчального закладу та виберіть зі списку",
      "registration-school-checkbox": "Не є учнем словацької школи",
      "registration-school-checkbox-hint": "батьки намагалися записати мене до словацької школи, але там, на жаль, не було вільних місць",
      "registration-city-ua-hint": "почніть вводити назву міста чи населеного пункту у Словаччині та виберіть зі списку",
      "registration-name": "Ім'я",
      "registration-surname": "Прізвище",
      "registration-idnumber": "Ідентифікаційний номер (Rodné číslo)",
      "registration-idnumber-2": "або Український індивідуальний податковий номер (ІПН або РНОКПП)",
      "registration-idnumber-3": "Аби продавцю було простіше вас ідентифікувати, вкажіть Ідентифікаційний номер (Rodné číslo) або будь-який з зазначених типів інформації",
      "registration-id-number-type": "Оберіть тип даних/документу",
      "registration-address": "Вулиця та номер будинку (які вказано на посвідченні особи)",
      "registration-address-ua": "Вулиця та номер будинку",
      "registration-address-hint-ua": "у Словаччині або в Україні, латиницею. Якщо у Свідоцтві про тимчасовий притулок адреса відсутня, вкажіть адресу реєстрації в Україні.",
      "registration-address-student": "Вулиця та номер будинку у Словаччині",
      "registration-address-student-hint": "які вказано у Свідоцтві біженця. Якщо в Свідоцтві адресу не вказано, залиште поле пустим.",
      "registration-town": "Місто",
      "registration-town-hint": "почніть вводити назву міста чи населеного пункту у Словаччині та виберіть зі списку",
      "registration-town-student": "Місто",
      "registration-town-student-hint": "почніть вводити назву міста чи населеного пункту у Словаччині та виберіть зі списку",
      "registration-town-parent": "Місто",
      "registration-town-parent-hint": "у Словаччині або в Україні",
      "registration-postcode": "Поштовий індекс",
      "registration-postcode-hint": "у форматі 12345, якщо ви не впевненні щодо свого словацького поштового індексу, скористайтеся <a href='https://psc.posta.sk/' target='_blank'>підказкою</a>",
      "registration-postcode-parent-hint": "у Словаччині або в Україні, якщо ви не впевненні щодо свого словацького поштового індексу, скористайтеся <a href='https://psc.posta.sk/' target='_blank'>підказкою</a>",
      "registration-name-institution": "Назва",
      "registration-ico": "Ідентифікаційний номер організації (IČO)",
      "registration-title-parent1": "Інформація про законного представника",
      "registration-title-parent2": "Інформація про другого законного представника",
      "registration-parent-is-institution": "Законним представником є заклад",
      "registration-only-parent1": "Учень / студент має лише одного законного представника",
      "registration-show-parent1": "Показати інформацію про першого законного представника",
      "registration-show-parent2": "Показати інформацію про другого законного представника",
      "registration-ifo": "Ідентифікатор біженця (odídenca)",
      "registration-ifo-2": "або Номер закордонного паспорту",
      "registration-nationality": "Громадянство",
      "registration-relationship": "Правові відносини",

      "reason-title": "Учень або студент є (<a href=\"https://ukrajinskyziak.sk/cielova-skupina-ua\" target=\"_blank\">детальна інформація</a>)",
      "reason-title-ua": "Учень або студент є (<a href=\"https://ukrajinskyziak.sk/cielova-skupina-ua\" target=\"_blank\">детальна інформація</a>)",
      "reason0": "учнем першого класу середньої школи Словацької Республіки або учнем п'ятого класу (квінти) 8-річної середньої школи Словацької Республіки",
      "reason1": "у стані матеріальної скрути",
      "reason2": "з особливими освітніми потребами відповідно до § 2 (p) Закону № 245/2008 Зб. зак., що виникли в соціально несприятливому середовищі",
      "reason3": "членом сім'ї, сукупний дохід якої нижчий за 60% від медіанного доходу",

      "consents": "Згоди",
      "consent-title0": "ЗГОДА З УМОВАМИ УГОДИ",
      "consent-title1": "ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ",
      "consent-title2": "ЗГОДА НА ПЕРЕВІРКУ ВІДПОВІДНОСТІ ЦІЛЬОВОЇ ГРУПИ КРИТЕРІЯМ ПРИЙНЯТНОСТІ В ДЕРЖАВНИХ РЕЄСТРАХ",
      "consent-title3": "ЗГОДА НА ВИКОРИСТАННЯ В РЕКЛАМНИХ ЦІЛЯХ",
      "consent0": "Підтверджую, що я ознайомився(-лась) з <a href=\"https://ukrajinskyziak.sk/zmluvne-podmienky-ua\" target=\"_blank\">Умовами угоди</a> участі в проєкті Цифрова допомога для учнів з України та погоджуюся з їхнім формулюванням. Надаючи свою згоду, ви встановлюєте договірні відносини між вами та Цифровою коаліцією.",
      "consent1": "Підтверджую, що прочитав та зрозумів <a href=\"https://ukrajinskyziak.sk/podmienky-ochrany-osobnych-udajov-ua\" target=\"_blank\">Політику конфіденційності</a>.",
      "consent2": "Я погоджуюся на (i) надання Цифровою коаліцією обраним органам державної влади даних в обсязі, зазначеному мною в реєстраційній формі, з метою перевірки цільової групи Проєкту, (ii) обробку наданих даних органами державної влади, які здійснюють перевірку цільової групи Проєкту, та (iii) подальше надання органами державної влади результату перевірки Цифровій коаліції. Цифрова коаліція надає інформацію обраним державним органам, які оброблятимуть дані для перевірки критеріїв цільової групи проекту в інформаційних системах державного управління та згодом нададуть цю інформацію для перевірки виконання умов цифрової коаліції, що слугуватиме передумовою для включення студента до числа отримувачів цифрової допомоги та виконання зобов’язань Цифрової коаліції згідно з Угодою про участь студента в проекті. Отримання результату перевірки з інформаційних систем державного управління є необхідною умовою для виконання Договору про участь учня в Проекті. Я даю свою згоду на період (i) терміну дії договірних відносин із Digital Coalition і 10 років після їх закінчення або (ii) до 31.12.2028, залежно від того, що настане раніше. Я розумію, що можу відкликати свою згоду в будь-який момент. Мені відомо, що в разі відкликання цієї згоди або якщо цю згоду не буде надано, я не зможу брати участь у Проекті та/або бути включеним до авторизованих одержувачів цифрової допомоги. Детальніше про відкликання <a href=\"https://ukrajinskyziak.sk/suhlas-ua\" target=\"_blank\">згоди</a> та ваші права можна знайти в <a href=\"https://ukrajinskyziak.sk/podmienky-ochrany-osobnych-udajov-ua\" target=\"_blank\">Умовах захисту персональних даних</a>.",
      "consent3": "Я погоджуюся на обробку моїх контактних даних Цифровою коаліцією, включаючи адресу електронної пошти та номер телефону, для маркетингових і рекламних цілей з метою підвищення цифрової грамотності. Мені відомо, що надання цієї згоди не є необхідним для виконання будь-яких договірних чи юридичних зобов’язань, і її ненадання не матиме жодного впливу на оцінку заявки на включення до Проекту, а також на будь-які інші негативні наслідки для особи законного представника чи студента. Я розумію, що можу відкликати свою згоду в будь-який момент. Я надаю цю згоду на 3 роки з моменту її надання або до моменту її відкликання. Докладніше про відкликання згоди та ваші права можна знайти в <a href=\"https://ukrajinskyziak.sk/podmienky-ochrany-osobnych-udajov-ua\" target=\"_blank\">Умовах захисту персональних даних</a>.",
      "consent0-ua": "Підтверджую, що я ознайомився(-лась) з <a href=\"https://ukrajinskyziak.sk/zmluvne-podmienky-ua\" target=\"_blank\">Умовами угоди</a> участі в проєкті Цифрова допомога для учнів з України та погоджуюся з їхнім формулюванням. Надаючи свою згоду, ви встановлюєте договірні відносини між вами та Цифровою коаліцією.",
      "consent1-ua": "Підтверджую, що прочитав та зрозумів <a href=\"https://ukrajinskyziak.sk/podmienky-ochrany-osobnych-udajov-ua\" target=\"_blank\">Політику конфіденційності</a>.",
      "consent2-ua": "Я погоджуюся на (i) надання Цифровою коаліцією обраним органам державної влади даних в обсязі, зазначеному мною в реєстраційній формі, з метою перевірки цільової групи Проєкту, (ii) обробку наданих даних органами державної влади, які здійснюють перевірку цільової групи Проєкту, та (iii) подальше надання органами державної влади результату перевірки Цифровій коаліції. Цифрова коаліція надає інформацію обраним державним органам, які оброблятимуть дані для перевірки критеріїв деяких цільової групи проекту в інформаційних системах державного управління та згодом нададуть цю інформацію для перевірки виконання умов цифрової коаліції, що слугуватиме передумовою для включення студента до числа отримувачів цифрової допомоги та виконання зобов’язань Цифрової коаліції згідно з Угодою про участь студента в проекті. Отримання результату перевірки з інформаційних систем державного управління є необхідною умовою для виконання Договору про участь учня в Проекті. Я даю свою згоду на період (i) терміну дії договірних відносин із Digital Coalition і 10 років після їх закінчення або (ii) до 31.12.2028, залежно від того, що настане раніше. Я розумію, що можу відкликати свою згоду в будь-який момент. Мені відомо, що в разі відкликання цієї згоди або якщо цю згоду не буде надано, я не зможу брати участь у Проекті та/або бути включеним до авторизованих одержувачів цифрової допомоги. Детальніше про відкликання <a href=\"https://ukrajinskyziak.sk/suhlas-ua\" target=\"_blank\">згоди</a> та ваші права можна знайти в <a href=\"https://ukrajinskyziak.sk/podmienky-ochrany-osobnych-udajov-ua\" target=\"_blank\">Умовах захисту персональних даних</a>.",
      "consent3-ua": "Я погоджуюся на обробку моїх контактних даних Цифровою коаліцією, включаючи адресу електронної пошти та номер телефону, для маркетингових і рекламних цілей з метою підвищення цифрової грамотності. Мені відомо, що надання цієї згоди не є необхідним для виконання будь-яких договірних чи юридичних зобов’язань, і її ненадання не матиме жодного впливу на оцінку заявки на включення до Проекту, а також на будь-які інші негативні наслідки для особи законного представника чи студента. Я розумію, що можу відкликати свою згоду в будь-який момент. Я надаю цю згоду на 3 роки з моменту її надання або до моменту її відкликання. Докладніше про відкликання згоди та ваші права можна знайти в <a href=\"https://ukrajinskyziak.sk/podmienky-ochrany-osobnych-udajov-ua\" target=\"_blank\">Умовах захисту персональних даних</a>.",

      "school-none-consent-title1": "ТЕСТ СЛОВАЦЬКОЇ МОВИ",
      "school-none-consent-title2": "IT FITNESS TEST",
      "school-none-consent-title3": "ЗАЯВА ПІД ЧЕСНЕ СЛОВО",
      "school-none-consent-info1": "Зобов'язуюсь пройти тест <a href=\"https://ukrajinskyziak.sk/test-a1-ua\" target=\"_blank\">Тест для самооцінки рівня володіння словацькою мовою, як іноземною (другою) мовою</a> до 10.10.2023.",
      "school-none-consent-info2": "Зобов'язуюсь пройти тест <a href=\"https://itfitness.eu/uk\" target=\"_blank\">IT FITNESS TEST</a> до 10.10.2023.",
      "school-none-consent-info3": "Я щиро заявляю, що маю(-ємо) інтерес у тому, щоб зареєстрована дитина була включена до державної програми освіти в Словацькій Республіці, і що мною (нами) було проведено необхідні дії для пошуку підходящої школи. Станом на день реєстрації не було можливості зарахувати дитину до будь-якої підходящої школи, яка б відповідала потребам дитини з точки зору віддаленості від місця проживання, спрямованості та потреб у навчанні дитини.",
      "school-none-value": 'жодна',

      "header-home": "Головна",
      "header-callcentrum": "Служба підтримки",

      "footer-company": "Digitálna koalícia — Національна коаліція цифрових навичок і професій Словацької Республіки",
      "footer-company-address-line-1": "Mlynské nivy 5, 821 09",
      "footer-company-address-line-2": "Bratislava Slovenská republika",
      "footer-phone-info": "(робочі дні, 9:00-17:00)",
      "footer-company-realisation-info": "Проект співфінансується Європейським Союзом.",
      "footer-company-realisation-info-ua": "Проект фінансується Європейським Союзом.",
      "footer-more-info": "Подробиці",

      "logo-digiziak": "Український учень лого",
      "logo-digi-coalition": "Логотип цифрової коаліції",
      "logo-eu": "Логотип Європейського фонду регіонального розвитку",
      "logo-opii": "Логотип Міністерства транспорту та будівництва Словацької Республіки",
      "logo-mirri": "Логотип Міністерства інвестицій, регіонального розвитку та інформатизації Словацької Республіки",

      "consent-required": "Потрібна згода",
      "error-consent-gdpr": "Ви повинні дати згоду на обробку персональних даних",
      "error-missing-reason": "Виберіть принаймні одну причину",
      "cookies-settings": "Налаштування файлів cookie",
      "cookies-necessary": "Необхідні файли cookie",
      "cookies-necessary-text": "Ці файли cookie необхідні для правильного та безпечного функціонування веб-сайту та не можуть бути деактивовані.",
      "cookies-analytics": "Аналітичні файли cookie",
      "cookies-analytics-text": "Аналітичні файли cookie дозволяють веб-сайту підраховувати відвідування, джерела відвідувань і поведінку на веб-сайті, щоб вимірювати та покращувати продуктивність нашого сайту. Для цих вимірювань ми використовуємо аналітику інших компаній - Google Analytics.",
      "cookies-allow-necessary": "Дозволити лише необхідні",
      "cookies-allow-selected": "Дозволити обрані",
      "cookies-allow-all": "Дозволити всі",

      "result-part1": "Дякуємо за інтерес та реєстрацію. На вказаний номер телефону {{phone, string}} ми надіслали SMS із кодом підтвердження, який ви можете ввести нижче.",
      "result-part2": "Після перевірки номера телефону введені вами дані будуть перевірені в державних реєстрах на відповідність критеріям для отримання допомоги. Перевірка буде проводитися з двотижневим інтервалом, про її результат ми повідомлятимемо за вказаним номером телефону. У разі виникнення запитань звертайтеся на інформаційну лінію проекту <a href='tel:{{contactPhone,string}}'>{{contactPhone, string}}</a> у будні з 9:00 до 17:00 або надішліть нам електронний лист на <a href='mailto:{{contactEmail,string}}'>{{contactEmail, string}}</a>.",

      "login-title": "Prihlásenie",
      "login-login": "Prihlásiť",
      "login-codeOrPassword": "Heslo alebo kód tutoriálu",
      "login-newPassword": "Nové heslo",
      "login-newPasswordAgain": "Nové heslo ešte raz",
      "login-password": "Heslo",
      "login-failed": "Nepodarilo sa prihlásiť",
      "salesman-validation": "Vyhľadanie poukazu",
      "supervisor-vouchers": "Zoznam poukazov",

      "lookup-title": "Vyhľadanie poukazu",
      "lookup-desc": "Zadajte kód poukazu",
      "lookup-code": "Kód poukazu",
      "lookup-student-idnumber": "Rodné číslo žiaka",
      "lookup-student-idnumber-ua": "Ідентифікаційний номер (Rodné číslo) учня",
      "lookup-parent-idnumber": "Rodné číslo zákonného zástupcu",

      "voucher-code": "Kód poukazu",
      "voucher-code-hint": "XXX-YYY-ZZZ",
      "voucher-search": "Kód poukazu, meno, rodné číslo ...",
      "voucher-search-hint": "",
      "voucher-detail-title": "Poukaz",
      "voucher-detail-desc": "Detail poukazu",
      "voucher-lock": "Pokračovať v poskytnutí príspevku",
      "voucher-locked-for-other-salesman": "Poukaz je blokovaný pre iného predajcu",
      "voucher-invalid-params": "Zadané hodnoty sú nesprávne",
      "voucher-check-failed": "Nepodarilo sa overiť údaje",
      "voucher-lock-failed": "Nepodarilo sa zamknúť poukaz",
      "voucher-repair-data-and-continue": "Uložiť údaje a pokračovať v poskytnutí príspevku",
      "voucher-process-finish": "Dokončiť poskytnutie príspevku",
      "voucher-process-cancel": "Ukončiť bez poskytnutia príspevku",
      "voucher-cant-load": "Nepodarilo sa načítať poukaz",
      "voucher-process-cancel-confirm": "Naozaj chcete ukončiť poskytovanie príspevku?",
      "voucher-idCard": "Číslo občianskeho preukazu",
      "voucher-sale-without-setup": "Študent 1. ročníka strednej školy - zákazník si neželá inštaláciu a prvé spustenie zariadenia.",
      "voucher-searchByIdOrPhone": "Vyhľadaj podľa rodného / telefónneho čísla",
      "voucher-verified": "overený nárok",
      "voucher-unverified": "neoverený nárok",
      "voucher-refused": "zamietnutý nárok",
      "voucher-unused": "nepoužitý",
      "voucher-appliedAt": "uzamknutý predajcom",
      "voucher-confirmedAt": "použitý",
      "voucher-phoneVerified": "overené tel. číslo",
      "voucher-phoneNotVerified": "čaká na overenie tel. čísla",
      "voucher-salesInfo": "Informácie o predaji",
      "voucher-details": "Informácie o poukaze",
      "voucher-delete": "Odstrániť poukaz (GDPR)",
      "voucher-delete-success": "Poukaz odstránený",
      "voucher-delete-confirm": "Naozaj chcete odstrániť poukaz?",
      "voucher-release-sale-voucher": "Zrušiť predaj",
      "voucher-released-sale-success": "Predaj poukazu bol zrušený",
      "voucher-released-sale-confirm": "Naozaj chcete zrušiť predaj poukazu?",

      "voucher-check-data-title": "Kontrola údajov poukazu {{voucher, string}}",
      "voucher-check-data-subtitle": "Ak nesedí <strong>adresa</strong> s údajmi v občianskom preukaze, môžete ju opraviť a následne uložiť",
      "voucher-check-data-appendix": "Potvrdzujem, že zadané údaje súhlasia s údajmi v občianskom preukaze",
      "voucher-model-fields-title": "Poukaz {{voucher, string}}",
      "voucher-model-fields": "Informácie o zariadení",
      "voucher-model-field-model": "Model",
      "voucher-model-field-description": "Typ zariadenia",
      "voucher-model-field-serialNumber": "Sériové číslo",
      "voucher-model-field-descriptionAccessories": "Popis oprávneného príslušenstva",
      "voucher-model-field-priceDevice": "Cena zariadenia s DPH",
      "voucher-model-field-priceAccessories": "Cena príslušenstva s DPH",
      "voucher-model-field-totalPrice": "Cena nákupu spolu",
      "voucher-model-field-reference": "Variabilný symbol",
      "voucher-model-updated": "Detaily poukazu aktualizované",
      "voucher-model-desc-select": "Vyberte zo zoznamu",
      "voucher-model-desc-optionNotebook": "Notebook",
      "voucher-model-desc-optionTablet": "Tablet",
      "voucher-model-desc-optionAllInOne": "All in one počítač",
      "voucher-model-update-failed": "Nepodarilo sa uložiť údaje",

      "voucher-created": "Registrácia vytvorená",
      "voucher-result-title": "Poukaz bol úspešne použitý.",
      "voucher-student": "Žiak",
      "voucher-school": "Škola",
      "voucher-salesman": "Predajca",
      "voucher-parent": "Zákonný zástupca",

      "voucher-title": "Poukaz {{voucher, string}}",
      "voucher-deactivated": "Poukaz deaktivovaný",

      "attachments": "Prílohy",
      "attachments-upload": "Nahrávanie príloh",
      "attachment": "Príloha",
      "attachment-add": "Nahraj ďaľší doklad",
      "attachment-upload": "Nahraj prílohu",
      "attachment-delete-confirm": "Naozaj chcete odstrániť prílohu? Odstránenie prílohy sa nedá vrátiť späť.",
      "attachment-pleaseUpload": "Prosím, nahrajte všetky povinné prílohy",
      "attachment-contract": "Zmluva",
      "attachment-protocol": "Preberací protokol",
      "attachment-invoice": "Účtovný doklad",
      "attachment-sync-warning": "Pre nahratie dokumentu kliknite na \"Uložiť\"",
      "attachment-sync-failed": "Nepodarilo sa nahrať dokument",

      "import-title": "Import používateľov",
      "import-rows": "Importované dáta",
      "import-select-file": "Vyber súbor pre import",
      "import-user-type": "Typ používateľa",
      "import-errorRows": "Chybné dáta v riadkoch: {{rows, string}}",
      "import-user-email-success": "Používateľ úspešne naimportovaný: {{email, string}}",
      "import-user-email-error": "Chyba pri importe používateľa: {{email, string}}. {{error, string}}",
      "import-user-result-success": "Import prebehol úspešne",
      "import-user-result-error": "V importe sa nachádzajú chyby",

      "user-typeAdmin" : "Admin",
      "user-typeSchool" : "Manažér školy",
      "user-typeCallcenter" : "Call centrum",
      "user-typeStoreChain" : "Manažér obchodného reťazca",
      "user-typeSalesman" : "Predajca",

      "vouchers-code": "Kód",
      "vouchers-applied": "Aplikovaný",
      "vouchers-confirmed": "Potvrdený",
      "vouchers-student": "Žiak",
      "vouchers-priceDevice": "Cena zariadenia",
      "vouchers-priceAccessories": "Cena príslušenstva",
      "vouchers-priceTotal": "Cena spolu",

      "export-title": "Export dát",
      "export-dateFrom": "Dátum od",
      "export-dateTo": "Dátum do",
      "export-action-xlsx": "Exportuj .xlsx",
      "export-action-xml": "Exportuj .xml",
      "storeChain-list-title": "Siete predajní",
      "storeChain-title": "Sieť predajní",
      "store-title": "Prevádzka",

      "user-name": "Meno",
      "user-email": "Email",
      "user-create-title": "Vytvorenie používateľa",
      "user-edit-title": "Editácia používateľa",
      "user-supervisor": "Supervízor",
      "user-saved": "Používateľ uložený",
      "user-clear-password": "Vymazať heslo",
      "user-clear-password-confirm": "Naozaj chcete vymazať heslo?",
      "user-block": "Blokovať používateľa",
      "user-block-confirm": "Naozaj chcete zablokovať používateľa?",
      "user-blocked": "Používateľ zablokovaný",
      "user-password-cleared": "Heslo vymazané.",
      "user-not-found": "Používateľ neexistuje",
      "user-create": "Pridaj používateľa",
      "user-disabled-alert": "Používateľ deaktivovaný.",
      "user-not-activated": "Konto ešte nebolo aktivovanô",

      "relationship-parent": "Один з батьків",
      "relationship-officially-determined-guardian": "Опікун",
      "relationship-authorized-guardian": "Уповноважена особа",

      "option-slovak-republic": "Словацька Республіка",
      "option-other": "інше",

      "registration-page-title": "Реєстраційна форма | Український учень",

      "registration-radio-sk-rodne-cislo": "Ідентифікаційний номер (Rodné číslo)",
      "registration-radio-ua-tax-id": "Український індивідуальний податковий номер (ІПН або РНОКПП)",
      "registration-radio-ua-pass-number": "Номер закордонного паспорту",
      "registration-radio-sk-ifo": "Ідентифікатор біженця (odídenca)",
      "registration-radio-driver-license": "Посвідчення водія",
      "registration-radio-temporary-residence": "Prechodný pobyt",
      "ua-title": "Український учень",

      "ua-registration-end-title": "Проект \"Український учень\" завершено",
      "ua-registration-end-text": "<p>Проект \"Український учень\" завершено, цифрову допомогу можна було застосувати до 30 листопада 2023 року.</p><p>Ми отримали та обробили близько 10 500 реєстрацій у проекті \"Цифрова допомога для учнів з України\" (Український учень) – дякуємо!</p><p>Перевірку права на отримання цифрової допомоги, а також надсилання підтверджуючих SMS-кодів, було завершено і застосування цифрової допомоги, на придбання нового цифрового пристрою, можна було здійснити, у будь-якому, з понад 450 магазинів, залучених до проекту, до 30 листопада 2023 р.</p>",
    }
  }
};

const getStartLanguage = () => {
  if (isUAHost()) {
    return localStorage.getItem(UAConsts.LocalStorageLangKey) || 'sk'
  }

  return 'sk';
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getStartLanguage(),
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
